<ng-bs-toast-service />
<ng-bs-modal-service />
<navbar *ngIf="hasAuth" />
<main class="container-fluid">
    <div class="row h-100">
        <div class="sidebar border border-right p-0 bg-body-tertiary h-100 d-print-none" sidebar *ngIf="hasAuth"></div>
        <div class="col py-3 p-md-4 h-100 overflow-auto position-relative">
            <router-outlet />
        </div>
    </div>
</main>